import type { ApiPaymentTerms, EnumPaymentMethod } from '@Model';
import { getEnumPaymentMethodLabel, paymentMethodOptions } from '@Model';
import type { Column } from '@synqo/frontend-component-library';

export const paymentTermsColumns: Column<ApiPaymentTerms>[] = [
    { name: 'shorthand', label: 'Suchcode' },
    { name: 'label', label: 'Bezeichnung' },
    {
        name: 'payment_method',
        label: 'Zahlungsart',
        filterVariant: 'select',
        filterOptions: paymentMethodOptions,
        renderCell: ({ cellData }) => getEnumPaymentMethodLabel(cellData as EnumPaymentMethod),
    },
    { name: 'booking_code', label: 'Buchungscode' },
];
